
import React from 'react';

const FactoryUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M27.433 13.1a.996.996 0 00-1.06.12l-3.37 2.7V14a1.004 1.004 0 00-1.63-.78l-3.37 2.7V14a1.004 1.004 0 00-1.63-.78l-3.91 3.13-.46-7.41c-.04-.53-.47-.94-1-.94h-5c-.53 0-.96.41-1 .94l-1 16c-.02.28.08.55.27.75.19.2.45.31.73.31h22c.55 0 1-.45 1-1V14c0-.38-.22-.73-.57-.9zM10.443 16h-3.88l.12-2h3.62l.14 2zm.12 2l.12 2h-4.37l.12-2h4.13zm-.5-8l.12 2h-3.37l.12-2h3.13zm-4 14l.12-2h4.62l.12 2h-4.86zm19.94 0h-13.06l-.33-5.23.01.02 3.38-2.7V18a1.004 1.004 0 001.63.78l3.38-2.7V18a1.004 1.004 0 001.63.78l3.38-2.7V24h-.02z'
			></path>
			<path
				fill='#2d2d2d'
				d='M16.003 20h-2v3h2v-3zM19.003 20h-2v3h2v-3zM22.003 20h-2v3h2v-3zM25.003 20h-2v3h2v-3zM12.003 4c.57 0 .81.21 1.3.7.54.54 1.29 1.27 2.7 1.27 1.41 0 2.16-.74 2.7-1.27.49-.49.73-.7 1.3-.7.56 0 .8.22 1.29.71.55.54 1.3 1.29 2.71 1.29 1.62 0 2.12-1.01 2.39-1.55.22-.44.23-.45.61-.45V2c-1.62 0-2.12 1.01-2.39 1.55-.22.44-.23.45-.61.45-.56 0-.8-.22-1.29-.71-.55-.54-1.3-1.29-2.71-1.29s-2.16.74-2.7 1.27c-.49.48-.73.7-1.3.7-.57 0-.81-.21-1.3-.7-.54-.53-1.29-1.27-2.7-1.27-2.76 0-5 2.24-5 5h2c0-1.65 1.35-3 3-3z'
			></path>
			<path
				fill='#2d2d2d'
				d='M17.303 7.27c-.49.48-.73.7-1.3.7-.57 0-.81-.21-1.3-.7-.54-.53-1.29-1.27-2.7-1.27v2c.57 0 .81.21 1.3.7.54.54 1.29 1.27 2.7 1.27 1.41 0 2.16-.74 2.7-1.27.49-.49.73-.7 1.3-.7.56 0 .8.22 1.29.71.55.54 1.3 1.29 2.71 1.29V8c-.56 0-.8-.22-1.29-.71-.55-.54-1.3-1.29-2.71-1.29s-2.16.74-2.7 1.27zM26.003 30h-20v2h20v-2z'
			></path>
		</svg>
	);
};

export default FactoryUnderline;

